exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ItemsList__list__item___I3vae{cursor:pointer;display:flex;padding:0 20px;height:24px;align-items:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ItemsList__list__item___I3vae:hover:not(.ItemsList__list__item--disabled___-DoMB){background:#557eff;color:#fff}.ItemsList__list__item--disabled___-DoMB{cursor:default}\n", ""]);

// Exports
exports.locals = {
	"default-turquoise": "#0d91bd",
	"error-red": "#f9453e",
	"border-grey": "#e9e9e9",
	"white": "#fff",
	"default-blue": "#557eff",
	"glowing-blue": "#0d47ff",
	"text-black": "#555",
	"text-grey": "#778195",
	"disabled-grey-background": "#f9fafb",
	"disabled-light-grey-button": "#c2c2c2",
	"disabled-grey-text": "#a8a8a8",
	"success-green": "#03b571",
	"list-item-grey": "#f3f3f3",
	"outline-color": "#79c2db",
	"greyout": "#fafafa",
	"orange": "#f87748",
	"list__item": "ItemsList__list__item___I3vae",
	"list__item--disabled": "ItemsList__list__item--disabled___-DoMB"
};